
import Component from "vue-class-component"
import { Vue } from "vue-property-decorator"
import ReservierungVorbestellungLogic from "@/logic/bestellung/reservierung_vorbestellung_logic"
import BstlArtikel from "@/entities/common/bstl_artikel"
import ReservierungVorbestellung from "./ReservierungVorbestellung.vue"

@Component
export default class ReservierungVorbestellungArtikel extends Vue {
  logic: ReservierungVorbestellungLogic = null

  added(value: BstlArtikel) {
    this.logic.addArtikel(value)
  }

  mounted() {
    this.logic = (this.$parent as ReservierungVorbestellung).logic
    this.logic.createdListener = () => {
      if (this.logic.artikel == null) {
        this.logic.reloadArtikel(this.$route.params.id)
      }
    }
  }
}
